import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Text, ButtonsContainer } from 'components/common/Elements/Elements';

import classes from './FooterModalCustomers.module.scss';

const FooterModalCustomers = ({
  counter = 0,
  handleCancel,
  handleOpenModal,
  mode
}) => {
  const { t } = useTranslation(['activity']);
  return (
    <div className={classes.modal}>
      <div className={classes.wrap}>
        <div className={classes.counterWrap}>
          <Text className={classes.counter}>{counter}</Text>
        </div>
        <Text className={classes.description}>
          {t('activity:featureFlag.CUSTOMERS_SELECTED')}
        </Text>
      </div>
      <ButtonsContainer
        counter={counter}
        handleCancel={handleCancel}
        handleOpenModal={handleOpenModal}
        action={mode}
      />
    </div>
  );
};

FooterModalCustomers.propTypes = {
  counter: PropTypes.number,
  handleCancel: PropTypes.func,
  handleOpenModal: PropTypes.func,
  mode: PropTypes.string.isRequired
};

export default FooterModalCustomers;
